import { useCallback } from "react";
import { Badge } from "antd";
import { ReactComponent as NotificationIcon } from "assets/icon/notificationIcon.svg";
import useRequest from "features/home/hooks/useRequest";

const Notification = () => {
  const { showDrawer, drawer, getPendingTotal } = useRequest();

  return (
    <>
      <div
        onClick={showDrawer}
        style={{
          width: 40, height: 40, backgroundColor: "#f6f6f6", borderRadius: 10,
          display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer",
        }}
      >
        <Badge count={getPendingTotal()} size="small" offset={[-4, 4]}>
          <NotificationIcon width={24} height={24} />
        </Badge>
      </div>
      {drawer()}
    </>
  );
};

export default Notification;